export const reportsFr = {
  error: "Impossible de charger le rapport.",
  retry: "Réessayer",
  empty: "Aucune donnée pour cette période.",
  delta: "%{value} vs période précédente",
  days: "%{value} jour |||| %{value} jours",
  conversion_label: "Conversion :",
  loading: "Chargement…",
  legend: { current: "Période choisie", previous: "Période précédente" },
  filters: {
    label: "Filtres du rapport",
    period: "Période",
    from: "Du",
    to: "Au",
    rep: "Représentant",
    all_reps: "Tous les représentants",
    all: "Tous",
    trade: "Métier",
    region: "Région",
    source: "Source",
    category: "Catégorie",
    view: "Vue",
    compare: "Comparer à la période précédente",
    range_invalid:
      "La date de début doit précéder la date de fin. Mois en cours affiché.",
  },
  periods: {
    this_month: "Ce mois-ci",
    last_month: "Mois dernier",
    quarter: "Ce trimestre",
    custom: "Personnalisée",
  },
  funnel: {
    title: "Entonnoir de vente",
    prospecting: "Prospection",
    deals: "Deals",
    cohort: "Deals créés dans la période",
    snapshot: "Deals actuels par étape",
    win_rate: "Taux de conclusion",
    avg_won: "Vente moyenne",
    cycle: "Cycle de vente médian",
    steps: {
      called: "Compagnies appelées",
      reached: "Joints",
      interested: "Intéressés",
      demos_booked: "Démos réservées",
      demos_held: "Démos tenues",
    },
    columns: {
      stage: "Étape",
      count: "Deals actuels",
      amount: "Montant",
      reached: "Ont atteint l'étape",
      conv_next: "Conversion vers l'étape suivante",
      median_days: "Jours médians dans l'étape",
    },
  },
  unknown: "Non précisé",
  table_view: "Voir en tableau",
  index: {
    title: "Rapports",
    funnel: "Prospection et deals, conversions et cycle de vente",
    activity:
      "Appels, contacts, démos et temps de parole par jour et par représentant",
    call_outcomes:
      "Résultats par métier, région et heure — trouvez les meilleurs moments pour appeler",
    emails_title: "Courriels",
    emails: "Performance des campagnes et séquences",
    sources: "Deals et ventes par source",
    loss: "Deals perdus par raison et par représentant",
    quality:
      "Téléphones invalides, sans courriel, non assignés, doublons, inactifs",
  },
  activity: {
    title: "Activité par représentant",
    columns: {
      day: "Jour",
      rep: "Représentant",
      dials: "Appels",
      contacts: "Contacts",
      voicemails: "Messages",
      demos: "Démos",
      talk_time: "Temps de parole",
      first_call: "Premier appel",
      last_call: "Dernier appel",
      sessions: "Sessions",
    },
  },
  call_outcomes: {
    title: "Résultats d'appels",
    outcomes: "Résultats",
    heatmap: "Taux de contact par jour et heure",
    cell: "%{day} %{hour} h : %{smart_count} appel, %{rate} de contact |||| %{day} %{hour} h : %{smart_count} appels, %{rate} de contact",
    cell_empty: "%{day} %{hour} h : aucun appel",
    legend_low: "0 %",
    legend_high: "%{rate}",
    legend_none: "Aucun appel",
    day: "Jour",
    hour: "Heure",
    dials: "Appels",
    rate: "Taux de contact",
  },
  outcomes: {
    no_answer: "Pas de réponse",
    voicemail: "Message laissé",
    talked_callback: "Parlé – rappeler",
    demo_booked: "Démo réservée",
    brochure_sent: "Brochure envoyée",
    not_interested: "Pas intéressé",
    wrong_number: "Mauvais numéro",
    do_not_call: "Ne pas appeler",
    unlogged: "Non consigné",
  },
  weekdays: {
    1: "lundi",
    2: "mardi",
    3: "mercredi",
    4: "jeudi",
    5: "vendredi",
    6: "samedi",
    7: "dimanche",
  },
  loss: {
    title: "Raisons de perte",
    by_reason: "Deals perdus par raison",
    by_rep: "Raisons par représentant",
    reason: "Raison",
    count: "Deals",
    amount: "Montant",
  },
  sources: {
    title: "Sources des deals",
    deals: "Deals créés",
    won: "Gagnés",
    won_amount: "Ventes gagnées",
  },
  quality: {
    title: "Qualité des données",
    description: "Sur l'ensemble des compagnies.",
    invalid_phone: "Sans téléphone valide",
    no_email: "Sans courriel",
    unassigned: "Non assignés",
    duplicate_phone: "Doublons (même téléphone)",
    duplicate_name_city: "Doublons (nom + ville)",
    stale_90d: "Inactifs depuis 90 jours",
    share: "%{pct} des compagnies",
  },
};
